@if(formGroup() && node()) {
<div class="preview" [formGroup]="previewGroup">
    <div class="row">
        <mat-label class="label">Content Preview</mat-label>
        @if (node()?.preview?.content?.length) {
        <ng-container [formArray]="contentArray">
            @for (option of node()?.preview?.content; track option.name; let i = $index) {
            <app-option [formGroup]="$any($safeNavigationMigration(contentArray?.at(i)))" [model]="option" [meta]="metaOption" (delete)="onDeleteContent($event)"></app-option>
            }
        </ng-container>
        }
        <button [disabled]="!formGroup()?.valid" type="button" class="button" (click)="onContent()">
            <mat-icon class="small-icon">add_box</mat-icon>
        </button>
    </div>
    <div class="row">
        <mat-label class="label">Genus Preview</mat-label>
        @if (node()?.preview?.genus?.length) {
        <ng-container [formArray]="genusArray">
            @for (option of node()?.preview?.genus; track option.name; let i = $index) {
            <app-option [formGroup]="$any($safeNavigationMigration(genusArray?.at(i)))" [model]="option" [meta]="metaOption" (delete)="onDeleteGenus($event)"></app-option>
            }
        </ng-container>
        }
        <button [disabled]="!formGroup()?.valid" type="button" class="button" (click)="onGenus()">
            <mat-icon class="small-icon">add_box</mat-icon>
        </button>
    </div>
</div>
}
